import React, { useState, useEffect } from 'react';
import { Button, Grid, TextField } from '@mui/material';
import FilterSelectInput from '../../../sharedModules/form/components/FilterSelectInput';
import DatePickerField from '../../../sharedModules/form/components/DatePickerField';

// TODO: This component should fetch its own options, rather than receiving them as a prop

interface RecentEstimatesFilterBarProps {
  filterValues: Record<string, string>;
  setFilterValues: React.Dispatch<any>;
  filterOptions: Record<string, any[]>;
  onFilter: (filterValues: any) => void;
}

const RecentEstimatesFilterBar: React.FC<RecentEstimatesFilterBarProps> = (props) => {
  const { filterValues, setFilterValues, onFilter, filterOptions } = props;

  const handleFiltersKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') onFilter(filterValues);
  };

  const handleFilterChange = (key, value) => {
    let updatedFilterValues = { ...filterValues };

    updatedFilterValues[key] = value;
    sessionStorage.setItem('chillerFilterValues', JSON.stringify(updatedFilterValues));
    setFilterValues(updatedFilterValues);
    if (['company_name_eq', 'chiller_log_status_eq'].includes(key)) {
      onFilter(updatedFilterValues);
    }
  };

  const handleClear = () => {
    setFilterValues({
      chiller_jobs_scheduled_date_gteq: '2000-01-01',
      chiller_jobs_scheduled_date_lteq: '2100-01-01',
      chiller_jobs_company_name_eq: 'all',
      chiller_jobs_order_no_eq: '',
      status_eq: 'all',
    });
  };

  return (
    <>
      <Grid container spacing={1} alignItems="flex-start" onKeyDown={handleFiltersKeyPress}>
        <Grid item xs={12} md={2}>
          <FilterSelectInput
            value={filterValues?.chiller_jobs_company_name_eq}
            defaultChoice={{ label: 'All Customers', value: 'all' }}
            choices={[...filterOptions?.client_options]}
            valueChanged={(value) => handleFilterChange('chiller_jobs_company_name_eq', value)}
            label="Customer"
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <FilterSelectInput
            value={filterValues?.status_eq}
            choices={[
              { label: 'Any', value: 'all' },
              { label: 'Not Started', value: 'not_started' },
              { label: 'Overdue', value: 'overdue' },
              { label: 'Closed - No Log', value: 'closed_no_log' },
              { label: 'In Progress', value: 'in_progress' },
              { label: 'Pending Approval', value: 'pending_approval' },
              { label: 'Manual Review', value: 'manual_review' },
              { label: 'Approved', value: 'approved' },
              { label: 'Complete', value: 'complete' },
              { label: 'Log Not Needed', value: 'not_needed' },
            ]}
            valueChanged={(value) => handleFilterChange('status_eq', value)}
            label="Status"
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            label="Order"
            type="text"
            variant="standard"
            style={{ width: '100%', marginTop: 8 }}
            value={filterValues?.chiller_jobs_order_no_eq || ''}
            onChange={(e) => handleFilterChange('chiller_jobs_order_no_eq', e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <DatePickerField
            label="Start Date"
            value={filterValues?.chiller_jobs_scheduled_date_gteq}
            onChange={(date) => handleFilterChange('chiller_jobs_scheduled_date_gteq', date)}
            style={{ width: '100%', marginTop: 8 }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <DatePickerField
            label="End Date"
            value={filterValues?.chiller_jobs_scheduled_date_lteq}
            onChange={(date) => handleFilterChange('chiller_jobs_scheduled_date_lteq', date)}
            style={{ width: '100%', marginTop: 8 }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1} alignItems="flex-start">
        <Grid item>
          <Button onClick={() => onFilter(filterValues)} variant="contained" style={{ margin: '5px 0 15px' }}>
            Apply
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={handleClear} variant="contained" color="inherit" style={{ margin: '5px 5px 15px' }}>
            Clear
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default RecentEstimatesFilterBar;
